module.exports = __webpack_public_path__ + "static/media/Дусанова У. (ДУ).dff14d36.pdf";